// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment-container:has(.shipment-section--wide){max-width:1320px}.create-shipment-foldout{animation:create-shipment-foldout .4s linear}@keyframes create-shipment-foldout{0%{transform:translateY(-220px)}to{transform:translateY(0)}}.create-shipment-fold{animation:create-shipment-fold .4s linear}@keyframes create-shipment-fold{0%{transform:translateY(220px)}to{transform:translateY(0)}}", ""]);
// Exports
module.exports = exports;
